import form from './form.vue'

form.install = function(Vue) {
  Vue.component(form.name, form)
}

export default form
